module.exports = {
	"header": "Tasteline partners with Spotin ",
	"date": "2022/11/02",
	"imgSrc": "tasteline.png",
	"imgAlt": "Tasteline partners with Spotin to offer their website readers friction-free ‘content commerce’ experiences. ",
	"ingress": "The popular recipe website Tasteline, owned by Mathem, partners with the tech company Spotin to offer a new type of e-commerce.",
	"sections": [
		{
			"paragraphs": [
				"Tasteline will use Spotin’s ‘content commerce’ solution to give its website readers an opportunity to shop products directly from its articles and discover more products in a Spotin enabled e-shop. The speciality of this solution is, that it works in a friction-free way where products can be purchased from within content and images without redirecting the user to another site.",
				"Tasteline has inspired Swedish home chefs for over 20 years. It is one of the most loved websites for food content and recipes. The collaboration helps them bring better user experience, an opportunity to monetise content and increase their overall site engagement. They will initially launch ‘content commerce’ with the cookbooks category from Bonnierförlagen. This means, that anyone reading content or browsing through the Tasteline website, will be able to buy the cookbooks from within content images and also from the curated e-shop on the Tasteline website.",
				"Over time the website might extend their ‘content commerce’ offering to other product categories and segments using Spotin’s technology."
			],
			"quote": {
				"text": "“We at Tasteline and Mathem look forward to broaden our website offering and provide more opportunities for our users and readers to engage in food and fun. The collaboration of us and Spotin, together with Bonnierförlagen, will enhance our readers digital enjoyment for food, bring them new shopping opportunities of some of the best cookbooks at great prices. We hope that the collaboration with Spotin will contribute in gaining more seller partners, so we can offer our readers a wider range of products for shopping.”",
				"author": "Andreas Boman",
				"title": "Head of Growth på Mathem."
			}
		},
		{
			"quote": {
				"text": "“We are proud that Tasteline chose Spotin as their e-commerce partner for enabling shopping at the point of discovery and inspiration. We see that more and more content creators, publishers, and sellers are now using our solution to create new revenue streams. We are delighted to bring them such opportunities and see this as a strong proof that our technology is in demand.”",
				"author": "Kristoffer Karlsson",
				"title": "founder and CEO of Spotin."
			}
		},
		{
			"paragraphs": [
				"<br><strong>See Spotin's service live on Tasteline:</strong>",
				"<a href='https://www.tasteline.com/inspiration/i-sasong/host/laga-mat-med-svamp/' style='text-decoration: underline;'>Post with a shoppable book</a>",
				"<a href='https://www.tasteline.com/#/sp?s=1' style='text-decoration: underline;'>Tasteline’s shop</a>"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/12/article.json
// module id = 10
// module chunks = 0